module.exports = __webpack_public_path__ + "img/team-stefan-kramer.edee3f4d.jpg";